import type { HTMLAttributes } from 'react'
import { cn } from './cn'

/** White or mist, no border, little or no shadow; corners and shadow are the surface's tokens (DESIGN.md). */
export function Card({
  className,
  tone = 'white',
  ...props
}: HTMLAttributes<HTMLDivElement> & { tone?: 'white' | 'mist' }) {
  return (
    <div
      className={cn(
        'rounded-card p-4 sm:p-6',
        tone === 'white' ? 'bg-bg shadow-card' : 'bg-surface',
        className,
      )}
      {...props}
    />
  )
}
